import IApiError from "./IApiError";
import { ICommunicationError } from "@dev/hc-talk-talk";

export default class ApiError implements IApiError {
    private error: ICommunicationError;

    constructor(error: ICommunicationError) {
        this.error = error;
    }

    public get code(): number | undefined {
        return this.error.statusCode;
    }

    public get status(): string | undefined {
        return this.error.data && this.error.data.errors && this.error.data.errors.length > 0
            ? this.error.data.errors[0].code
            : undefined;
    }

    public get communicationError(): ICommunicationError {
        return this.error;
    }
}
